import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../_models/file-info-display-result-dto';

export class GeneralExpenseSubmissionResultDto {
    entryId: number;

    @Type(() => Date)
    date: Date;

    description: string;
    isBillable: string;
    amount: number;
    reimbursableAmount: number;

    @Type(() => FileInfoDisplayResultDto)
    receipts: FileInfoDisplayResultDto[];

    notes: string;
}
